export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8410.c47c6196.jpg";